import { makeStyles } from '@mui/styles';
const useStyles = makeStyles((theme) => ({
  moreHoriz: { alignItems: 'end', pointerEvents: 'auto' },
  removeBtn: { color: theme.palette.error.main },
  warningBtn: { color: theme.palette.warning.darker },
  addBtn: { color: theme.palette.success.main },
}));

export default useStyles;
